<template>
  <v-container
    id="RecoveyPass"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="success"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Restrablecimiento de la contraseña
              </h1>
            </div>
          </template>
          <v-card-text class="text-center">
            <v-form @submit.prevent="resetPass">
              <v-text-field
                v-model="email"
                :rules="[rules.required, rules.max]"
                color="secondary"
                label="Email"
                prepend-icon="mdi-email"
              />
              <div>
                <v-btn
                  elevation="1"
                  color="#DD4b39"
                  class="ma-1"
                  type="submit"
                >
                  Restrablecer
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
    <base-material-snackbar
      v-model="snackbar"
      min-width="650"
      :type="color"
      v-bind="{
        bottom: true,
        center: true
      }"
    >
      {{ message }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'PagesLogin',

    components: {

    },

    data: () => ({
      snackbar: false,
      color: 'info',
      message: '',
      email: null,
      error: null,
      rules: {
        required: value => !!value || 'Required.',
        max: v => (v || '').length <= 45 || 'A maximum of 45 caracteres is allowed',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      socials: [
        {
          href: '#',
          icon: 'mdi-facebook-box',
        },
        {
          href: '#',
          icon: 'mdi-twitter',
        },
        {
          href: '#',
          icon: 'mdi-github-box',
        },
      ],
    }),
    methods: {
      resetPass: async function () {
        await this.$http.post('/api/forgot-password',
                              {
                                email: this.email,
                              },
        ).then(response => {
          this.color = 'success'
          this.message = 'Mail enviado.'
          this.snackbar = true
        }).catch(error => {
          if (error.response) {
            // console.log(error.response)
            this.miArray = error.response.data.errors
            for (const property in this.miArray) {
              console.log(`${this.miArray[property]}`)
            }
            this.message = this.miArray[0]
            this.snackbar = true
            this.color = 'error'
          } else if (error.request) {
            // console.log(error.request)
          } else {
            // console.log('Error', error.message)
            this.message = 'Ocurrió un error al procesar la solicitud'
            this.snackbar = true
            this.color = 'error'
          }
        })
      },
    },
  }
</script>
